import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe, LowerCasePipe } from '@angular/common';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import {
  MatNativeDateModule,
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import {
  MatLegacyPaginatorModule as MatPaginatorModule,
  MatLegacyPaginatorIntl as MatPaginatorIntl,
} from '@angular/material/legacy-paginator';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import {
  MatLegacySnackBarModule as MatSnackBarModule,
  MAT_LEGACY_SNACK_BAR_DEFAULT_OPTIONS as MAT_SNACK_BAR_DEFAULT_OPTIONS,
} from '@angular/material/legacy-snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ContentListManagementRoutingModule } from './content-list-management-routing.module';
import { ContentListsComponent } from './content-lists/content-lists.component';
import { CustomMatPaginatorIntl } from './shared/custom-mat-paginator-intl';
import { CreateContentListComponent } from './create-content-list/create-content-list.component';
import { SharedModule } from '../shared/shared.module';
import { EditContentListComponent } from './edit-content-list/edit-content-list.component';
import { AddContentListComponent } from './add-content-list/add-content-list.component';
import { NotificationBarComponent } from '../shared/notification-bar/notification-bar.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ViewContentListComponent } from './view-content-list/view-content-list.component';
import { FilterContentListComponent } from './filter-content-list/filter-content-list.component';
import { DATE_FORMAT } from '../shared/constants/date-format.constant';
import {
  MatLegacyTabGroup as MatTabGroup,
  MatLegacyTabsModule as MatTabsModule,
} from '@angular/material/legacy-tabs';
import { AddTopicsToContentListComponent } from './add-topics-to-content-list/add-topics-to-content-list.component';
import { CmsConfirmationDialogComponent } from './shared/components/cms-confirmation-dialog/cms-confirmation-dialog.component';
import { SharedFormSectionsModule } from '../shared-form-sections/shared-form-sections.module';

@NgModule({
  declarations: [
    ContentListsComponent,
    CreateContentListComponent,
    EditContentListComponent,
    ViewContentListComponent,
    AddContentListComponent,
    FilterContentListComponent,
    AddTopicsToContentListComponent,
    CmsConfirmationDialogComponent,
  ],
  exports: [AddTopicsToContentListComponent],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    TitleCasePipe,
    LowerCasePipe,
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: { duration: 3000, panelClass: 'notification-panel' },
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
    },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: MAT_DATE_FORMATS, useValue: DATE_FORMAT },
  ],
  imports: [
    CommonModule,
    ContentListManagementRoutingModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatTooltipModule,
    MatTabsModule,
    MatDividerModule,
    MatAutocompleteModule,
    DragDropModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatListModule,
    SharedModule,
    SharedFormSectionsModule,
  ],
})
export class ContentListManagementModule {}
